import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

interface UnitSelectorProps {
  unit: string;
  customUnit: string;
  onUnitChange: (value: string) => void;
  onCustomUnitChange: (value: string) => void;
  isPoultry?: boolean;
}

export const UnitSelector = ({
  unit,
  customUnit,
  onUnitChange,
  onCustomUnitChange,
  isPoultry = false,
}: UnitSelectorProps) => {
  const handleValidateCustomUnit = () => {
    if (customUnit.trim()) {
      onUnitChange(customUnit.trim());
    }
  };

  return unit !== "custom" ? (
    <Select value={unit} onValueChange={onUnitChange}>
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {isPoultry ? (
          <>
            <SelectItem value="Tête">Tête</SelectItem>
            <SelectItem value="Lot">Lot</SelectItem>
            <SelectItem value="Carton">Carton</SelectItem>
            <SelectItem value="custom">Autre...</SelectItem>
          </>
        ) : (
          <>
            <SelectItem value="Pièce">Pièce</SelectItem>
            <SelectItem value="Carton">Carton</SelectItem>
            <SelectItem value="Kg">Kg</SelectItem>
            <SelectItem value="custom">Autre...</SelectItem>
          </>
        )}
      </SelectContent>
    </Select>
  ) : (
    <div className="flex gap-2">
      <Input
        value={customUnit}
        onChange={(e) => onCustomUnitChange(e.target.value)}
        placeholder="Entrez votre unité"
        required
      />
      <Button 
        type="button" 
        variant="outline"
        onClick={handleValidateCustomUnit}
        className="px-3 text-green-600 hover:text-green-700 hover:bg-green-50"
      >
        <Check className="h-4 w-4" />
      </Button>
      <Button 
        type="button" 
        variant="outline"
        onClick={() => {
          onUnitChange(isPoultry ? "Tête" : "Pièce");
          onCustomUnitChange("");
        }}
      >
        Retour
      </Button>
    </div>
  );
};